import { useRouteContext, Link } from "@tanstack/react-router";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card } from "@/components/ui/card";
import { Icon } from "@/components/icon";
import { Button } from "@/components/ui/button";

export function CreateEventButton() {
	const { session, club } = useRouteContext({ from: "__root__" });
	const user = session?.user;

	const canCreateEvent =
		user && club?.permissions.some((p) => p.slug === "CLUB_ADMIN");

	if (!canCreateEvent) {
		return null;
	}

	return (
		<Link to="/eventos/novo">
			<Card className="p-6 flex flex-row items-center justify-between h-[86px]">
				<div className="flex flex-row flex-1 items-center justify-start gap-3 text-card-foreground">
					<Avatar className="size-10">
						<AvatarImage src={user.photo?.signedUrl} />
						<AvatarFallback>{user.avatarFallback!}</AvatarFallback>
					</Avatar>

					<span>Criar um novo evento</span>
				</div>

				<Button size="icon">
					<Icon name="Plus" />
				</Button>
			</Card>
		</Link>
	);
}
